import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
export class PiggyBreakBoneAnimationResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("PiggyBreakBoneAnimationResourcePackage");
    }
    public get assets_views_piggy_break_bone_animation_svin_break_atlas(): any {
        return this.resource<any>("assets/views/piggy_break_bone_animation/svin_break.atlas");
    }
    public get assets_views_piggy_break_bone_animation_svin_break_json(): Object {
        return this.resource<Object>("assets/views/piggy_break_bone_animation/svin_break.json");
    }
}

